import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { PartnerCustomerListItem } from '../../api/queries';
import classes from './CustomerTable.module.css';
import { formatNorwegianDate } from '../../utils/dateFormatters';
import { formatNOK } from '../../utils/currencyFormatters';
import { Routes } from '../../enums/Routes';

interface CustomerTableProps {
  customers: PartnerCustomerListItem[];
}

const formatNumber = (num: number | null): string => {
  if (num === null) return '∞';
  return num.toLocaleString('nb-NO');
};

export const CustomerTable = ({ customers }: CustomerTableProps): ReactElement => {
  const navigate = useNavigate();

  const handleRowClick = (customerId: number) => {
    const route = Routes.PartnerAdminCustomerDetail.replace(':customerId', String(customerId));
    navigate(route);
  };

  return (
    <div className={classes.tableContainer}>
      <table className={classes.table}>
        <thead>
          <tr>
            <th>Kunde</th>
            <th>Opprettet</th>
            <th>Team</th>
            <th>SMS</th>
            <th>Lisenser</th>
            <th>Cashback (mnd)</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer) => (
            <tr
              key={customer.id}
              onClick={() => handleRowClick(customer.id)}
              className={classes.clickableRow}
            >
              <td className={classes.nameCell}>
                <strong>{customer.name}</strong>
              </td>
              <td>{formatNorwegianDate(customer.createdAt)}</td>
              <td>{customer.teamCount}</td>
              <td>
                {customer.smsQuota === null || customer.smsQuota === 0
                  ? 'Deaktivert'
                  : `${formatNumber(customer.smsUsed)} / ${formatNumber(customer.smsQuota)}`}
              </td>
              <td>
                {customer.availableSeats === null || customer.availableSeats === 0
                  ? 'Ubegrenset'
                  : `${formatNumber(customer.seatsUsed)} / ${formatNumber(customer.availableSeats)}`}
              </td>
              <td className={classes.cashbackCell}>
                {formatNOK(customer.monthlyCashbackNOK)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
